var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 20V18.3333C16 17.4493 15.6087 16.6014 14.9121 15.9763C14.2155 15.3512 13.2708 15 12.2857 15H6.71429C5.7292 15 4.78445 15.3512 4.08789 15.9763C3.39133 16.6014 3 17.4493 3 18.3333V20",
    stroke: "#54FF99",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4C16.5726 4.20101 17.0796 4.65378 17.4416 5.28725C17.8036 5.92072 18 6.69902 18 7.5C18 8.30098 17.8036 9.07928 17.4416 9.71275C17.0796 10.3462 16.5726 10.799 16 11",
    stroke: "#54FF99",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20V18.2964C20.9993 17.5415 20.7044 16.8082 20.1614 16.2115C19.6184 15.6149 18.8581 15.1887 18 15",
    stroke: "#54FF99",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11C11.433 11 13 9.433 13 7.5C13 5.567 11.433 4 9.5 4C7.567 4 6 5.567 6 7.5C6 9.433 7.567 11 9.5 11Z",
    stroke: "#54FF99",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleUsers);
export default __webpack_public_path__ + "static/media/multiple-users.9b687bd42cd09bef8ab8b578c5dbb344.svg";
export { ForwardRef as ReactComponent };